<script>
    import { axisBottom, axisLeft } from 'd3-axis';
    import { scaleLinear, scaleBand } from 'd3-scale';
    import { monthTickValues, monthFormat, apMonthFormat } from '../utils/d3-utils';

    import Axis from './Axis.svelte';

    export let data;
    // export let domain;
    export let colors;
    export let waterYear;
    export let includeAxis = true;
    export let display;
    // export let bandwidth;
    // export let xRange;
    // export let xScale;
    // export let xLabel;

    // chart dimensions
    export let tickSize = 10;
    export let width;

    $: data = data.values;

    // set a breakpoint for mobile
    let mobileWidth = 600;

    let marginTop = 0;
    let marginRight = 10;
    let marginBottom = 20;
    let marginLeft = 10;

    // set pill height
    let pillHeight = 40;
    let rowPadding = 10;

    // set height based on number of water years in the data
    let height;
    if (includeAxis == true){
        height =  pillHeight + rowPadding + tickSize;
    } else {
        height = pillHeight + rowPadding;
    }

    // set up the x scale
    $: xRange = data.map((d) => d.date);

    $: xScale = scaleBand()
      .domain(xRange)
      .range([0, width - (width > mobileWidth ? 60 : 0) - marginLeft - marginRight])
      .padding(0);
    $: bandwidth = xScale.bandwidth();

    // let xScaleDesktop = scaleBand()
    //   .domain(xRange)
    //   .range([0, width - 60 - marginLeft - marginRight])
    //   .padding(0);
    // let bandwidthDesktop = xScaleDesktop.bandwidth();

    // let xScaleMobile = scaleBand()
    //   .domain(xRange)
    //   .range([0, width - 60 - marginLeft - marginRight])
    //   .padding(0);
    //   let bandwidthMobile = xScaleMobile.bandwidth();

    $: xTicks = []
    $: data.forEach(d => {
        if (d.date.getDate()==1) {
            xTicks.push(d.date);
        }
    })

    $: mobileTicks = xTicks.filter((item, index) => index % 2 === 0);
    
    $: customTickFormat = (d,i)=>{
        if ((i==0)|(monthFormat(d)=="Jan.")){
            return `${monthFormat(d)}`
        } else {
            return `${monthFormat(d)}`
        }
        ;
    }        
</script>
<div class="wy-{waterYear} {display}">
    {#if width <= mobileWidth}
        <h4>{waterYear}</h4>
    {/if}

    <svg {width} {height} viewBox="0,0,{width},{height}" role="graphics-document" aria-labelledby="{waterYear} daily precipitation">
        <g transform="translate({marginLeft},{marginTop})">
        <g class="axes">
            {#if includeAxis}
            <Axis
                axis={axisBottom}
                scale={ xScale }
                className="axis--x"
                yTranslate={height - marginTop - marginBottom }
                tickFormat={customTickFormat}
                tickValues={ width > mobileWidth ? xTicks : mobileTicks}
                xTranslate={ width > mobileWidth ? 60 : 0 }
            />
            {/if}
            {#if width > mobileWidth}
            <g class="axis axis--y" transform="translate(0,{marginTop})">
                <g
                    class="tick"
                    transform="translate(0, { (pillHeight+tickSize)/2 })"
                    height={pillHeight}
                >
                    <text class="axis-ticks">{waterYear}</text>
                </g>
            </g>
            {/if}
        </g>

        <g class="wy-{waterYear}" transform="translate(0, 0)">
            {#if width <= mobileWidth}
                <g class="tick mobile-tick">
                    <text>{waterYear}</text>
                </g>
            {/if}
            <g transform="translate({ width > mobileWidth ? 60 : 0}, 0)">
                {#each data as d}
                <rect
                    x={ xScale(d.date) }
                    width={ bandwidth }
                    y={0}
                    height={pillHeight}
                    data-value={ d.precip_totals }
                    data-date={ d.date }
                    fill={ (d.precip_totals != "M") ? colors(d.precip_totals) : "#ffffff" }
                    stroke=#ffffff
                    stroke-width=0.1
                />
                {/each}
            </g>
        </g>
        </g>
    </svg>
</div>